import React from 'react';
import './About.css';

export default function About() {
  const aboutImage = '/Personalphoto1.jpg';

  return (
    <section className="section about anchor" id="about">
      <div className="container about__inner">
        <div className="about__media">
          <img className="about__image" src={aboutImage} alt="Emmanuel Obeng" loading="lazy" />
        </div>
        <div className="about__content">
          <h2 className="about__title">Hi, I’m Emmanuel Obeng</h2>
          <p className="about__role">Certified Project Manager & IT Specialist</p>
          <p className="about__text">
            With over <strong>7 years of experience</strong> across{' '}
            <strong>Banking, FinTech, and IT services</strong>, I help teams deliver projects
            predictably while keeping IT environments stable, secure, and high-performing.
          </p>
          <p className="about__text">
            You get clear plans, strong stakeholder communication, and calm execution, plus
            dependable support to resolve issues fast and prevent repeat incidents.
          </p>
          <div className="about__chips" aria-label="Specialties">
            <span className="about__chip">Project Delivery</span>
            <span className="about__chip">Agile & Scrum</span>
            <span className="about__chip">IT Support</span>
            <span className="about__chip">Security</span>
          </div>
        </div>
      </div>
    </section>
  );
}
